import { generateGetHeaders } from 'api/generateGetHeaders';
import { getUserDetails } from 'api/getUserDetails';
import axios from 'axios';
import { Award } from 'models/award';
import { useQuery } from 'react-query';

// get available non selected awards
export const useAvailableAwards = (businessName: string) => {
  return useQuery<Award[], Error>(
    'AvailableAwards',
    async () => {
      const userDetails = await getUserDetails();
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/Portal/Awards/All`,
        generateGetHeaders(userDetails, businessName)
      );
      return data;
    },
    { enabled: !!businessName, refetchOnWindowFocus: false }
  );
};

// get all selected awards
export const useSelectedAwards = (businessName: string) => {
  return useQuery<Award[], Error>(
    'selectedAwards',
    async () => {
      const userDetails = await getUserDetails();
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/Portal/Awards`,
        generateGetHeaders(userDetails, businessName)
      );
      return data;
    },
    { enabled: !!businessName, refetchOnWindowFocus: false }
  );
};
